import { ScanSearch, Send, Handshake, Network } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const ENGINE = [
  { icon: ScanSearch, num: "01", t: "1-on-1 Portfolio Reviews", d: "Sit with working creative directors and tear your reel apart until it books meetings." },
  { icon: Send, num: "02", t: "Direct Agency Pitching", d: "Warm intros to partner agencies and production houses actively hiring juniors." },
  { icon: Handshake, num: "03", t: "Negotiation Guidance", d: "Know your day rate, your contract terms and when to walk away." },
  { icon: Network, num: "04", t: "Lifetime Alumni Network", d: "A private circle of PARA//EL graduates trading briefs, gigs and referrals." },
];

export const Career = () => (
  <section data-testid="career-support-section" className="bg-ink border-y border-line py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="13" eyebrow="After The Program" title="The Career Engine" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line">
        {ENGINE.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08} className="group bg-obsidian p-8 sm:p-10 hover:bg-surface transition-colors duration-300">
            <c.icon className="w-6 h-6 text-acid" strokeWidth={1.5} />
            <span className="block mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-dim">{c.num}</span>
            <h3 className="mt-3 font-head text-lg font-bold uppercase tracking-tight text-cream leading-tight">{c.t}</h3>
            <p className="mt-4 text-sm text-smoke leading-relaxed">{c.d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
